// extracted by mini-css-extract-plugin
module.exports = {"howToStartEarning":"styles_howToStartEarning__FjWtu","item":"styles_item__PLjIl","text":"styles_text__yesKn","mobile":"styles_mobile__cb3M8"};